import { render, staticRenderFns } from "./ParticipantClaimant.vue?vue&type=template&id=36c516aa"
import script from "./ParticipantClaimant.vue?vue&type=script&lang=js"
export * from "./ParticipantClaimant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports